import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=29b10e6a"
import script from "./Pin.vue?vue&type=script&lang=js"
export * from "./Pin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports